import PropTypes from "prop-types";
import React, { memo, useCallback, useState } from "react";
import GlobalSearch from "./GlobalSearch";
import { AUTO_COMPLETE_RESULT_COUNT } from "./constants";

const propTypes = {
  platform: PropTypes.object.isRequired,
  /** Text that will be shown on search bar */
  placeHolder: PropTypes.string,
  /** Specify the size of global seach */
  size: PropTypes.oneOf(["sm", "lg"]),
  /** CustomeGlobalSearch container classes */
  customClasses: PropTypes.string,
  /** This is the ref to the input box */
  inputRef: PropTypes.any,
};

/**
 * CustomGlobalSearch can be used for rendering search functionality
 * other than global search but having similar functionality
 */
export const CustomGlobalSearch = memo(function CustomGlobalSearch({
  platform,
  placeHolder,
  customClasses = "",
  inputRef,
  size,
}) {
  const [isActive, setActiveStatus] = useState(false);

  const handleSearchClick = useCallback(() => {
    setActiveStatus(!isActive);
  }, [isActive]);

  return (
    <div
      onClick={handleSearchClick}
      data-testing-id="Custom-Global-Search"
      className={customClasses}
    >
      <GlobalSearch
        isActive={isActive}
        size={size}
        platForm={platform}
        placeHolder={placeHolder}
        resultSize={AUTO_COMPLETE_RESULT_COUNT[platform.id]}
        inputRef={inputRef}
      />
    </div>
  );
});

CustomGlobalSearch.displayName = "CustomGlobalSearch";
CustomGlobalSearch.propTypes = propTypes;
